import { Logement } from './generated/Logement';
import { isNullOrWithSpace } from './utils';
import { normalizeDiagnosticFields } from './generated/logement/normalizeDiagnosticFields';

/**
 * Normalize logement data in two parts:
 * 1. Partie MANUELLE: non-diagnostic fields (trim, null if empty, etc.)
 * 2. Partie GÉNÉRÉE: diagnostic fields (CSV-driven trim + conditional clearing)
 */
export function normalizeLogement(logement: Logement): Logement {
  const normalized = { ...logement };

  // ===== Partie MANUELLE: normalisation des champs non-diagnostiques =====
  normalized.nomProgramme = normalized.nomProgramme?.toUpperCase();
  normalized.comment = isNullOrWithSpace(normalized.comment) ? undefined : normalized.comment;
  normalized.nomProgramme = isNullOrWithSpace(normalized.nomProgramme) ? undefined : normalized.nomProgramme;
  normalized.numBatiment = isNullOrWithSpace(normalized.numBatiment) ? undefined : normalized.numBatiment;
  normalized.numLogement = isNullOrWithSpace(normalized.numLogement) ? undefined : normalized.numLogement;
  normalized.numRpls = isNullOrWithSpace(normalized.numRpls) ? undefined : normalized.numRpls;
  normalized.adresse = isNullOrWithSpace(normalized.adresse) ? undefined : normalized.adresse;
  normalized.complementAdresse = isNullOrWithSpace(normalized.complementAdresse) ? undefined : normalized.complementAdresse;
  normalized.codePostal = isNullOrWithSpace(normalized.codePostal) ? undefined : normalized.codePostal;
  normalized.labelAutre = isNullOrWithSpace(normalized.labelAutre) ? undefined : normalized.labelAutre;
  // TODO: Apply LabelAutre conditional clearing if needed
  normalized.surface = isNullOrWithSpace(normalized.surface) ? undefined : normalized.surface;
  normalized.prixParking = isNullOrWithSpace(normalized.prixParking) ? undefined : normalized.prixParking;
  // TODO: Apply PrixParking conditional clearing if needed

  // ===== Partie GÉNÉRÉE: normalisation des champs diagnostiques =====
  return normalizeDiagnosticFields(normalized);
}
